export default {
	dayCols: (state, getters, rootState, rootGetters) => {
		state.dayCols = [];
		let cols = state.dayCols;
		let monthDays = new Date(state.searchMonth.substring(0, 4), state.searchMonth.substring(4, 6), 0).getDate();
		// console.log('monthDays', monthDays, cols, state.searchMonth);

		let col = {
			label: `${rootGetters['commonStore/getMessage_']('SWCC000218')}(${rootGetters['commonStore/getMessage_']('SWCC000217')})`,
			prop: 'userName',
			width: '250px',
			fixed: true
		};
		cols.push(col);

		col = {
			label: `${rootGetters['commonStore/getMessage_']('SWCC000349')}`,
			prop: 'sumQty',
			width: '150px',
			fixed: true
		};
		cols.push(col);

		for (var i = 1; i <= monthDays; i++) {
			let item = i < 10 ? '0' + i : i;
			col = {
				label: item.toString(),
				prop: 'day' + item,
				width: '120px'
			};

			cols.push(col);
		}

		return cols;
	}
};
